// ！！！！这个库有问题！！！！不要再用了，用@zz-common/zz-utils里的cookie
// ！！！！这个库有问题！！！！不要再用了，用@zz-common/zz-utils里的cookie
// ！！！！这个库有问题！！！！不要再用了，用@zz-common/zz-utils里的cookie
// ！！！！这个库有问题！！！！不要再用了，用@zz-common/zz-utils里的cookie
// ！！！！这个库有问题！！！！不要再用了，用@zz-common/zz-utils里的cookie
// ！！！！这个库有问题！！！！不要再用了，用@zz-common/zz-utils里的cookie
import Cookies from 'js-cookie'

// 默认option参数
const defOption = { expires: 10, domain: 'zhuanzhuan.com', path: '/' }

/**
 * 设置cookie
 */
interface SetOptions {
  expires?: number // 过期时间，单位天
  path?: string // 目录
  domain?: string // domain
}

export const setCookie = (key: string, value: string, options?: SetOptions) => {
  options = Object.assign({}, defOption, options)
  Cookies.set(key, value, options)
}

/**
 * 获取cookie
 */
export const getCookie = (key: string) => {
  return Cookies.get(key)
}

/**
 * 删除cookie
 */
interface DelOptions {
  path?: string // 目录
}
export const delCookie = (key: string, options?: DelOptions) => {
  return Cookies.remove(key, options)
}

/**
 * 获取PPU
 */
export const getPPU = () => {
  return Cookies.get('PPU')
}

/**
 * 获取UID
 */
export const getUID = () => {
  return Cookies.get('uid')
}

/**
 * 获取T
 */
export const getT = () => {
  return Cookies.get('t')
}
